var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.479 4.75a.535.535 0 00-.536.536v8.189a1.45 1.45 0 01-1.452 1.452H3.542a1.446 1.446 0 01-1.029-.425 1.444 1.444 0 01-.427-1.028V5.286c0-.888.721-1.608 1.61-1.608h9.428l-.702.707a.536.536 0 10.76.755l1.608-1.62a.536.536 0 00-.002-.756l-1.607-1.607a.536.536 0 00-.757.758l.692.693h-9.42a2.678 2.678 0 00-2.68 2.678v8.188a2.52 2.52 0 002.526 2.523h9.95a2.516 2.516 0 002.522-2.523V5.286a.536.536 0 00-.535-.535h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.765 10.643v2.143a.535.535 0 001.07 0v-2.143a.535.535 0 00-1.07 0h0zm3.218-4.286v6.429a.535.535 0 001.07 0V6.357a.535.535 0 10-1.07 0zm3.21 3.214v3.215a.535.535 0 001.071 0V9.57a.535.535 0 10-1.07 0z"
  }))));
}

export default SvgOther;